import {
  ELMA365ApplicationModel,
  ELMA365NamespaceComponent,
  ELMA365ProcessModel,
  ELMA365ToolComponent,
  ELMA365ToolsetComponentOutput,
} from '../../../../../gamma-api';

export const getComponentKey = (
  namespace: ELMA365NamespaceComponent,
  component: ELMA365ToolComponent | ELMA365ToolsetComponentOutput | ELMA365ApplicationModel | ELMA365ProcessModel
): string => `${namespace.identity.code}.${component.identity.code}`;
